import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {DxButtonModule, DxDateRangeBoxModule, DxTagBoxModule} from 'devextreme-angular';
import * as AspNetData from 'devextreme-aspnet-data-nojquery';

export type MyScoreFilters = {
    from: Date;
    to: Date;
    vendorIds?: string[];
    siteIds?: string[];
};

@Component({
    selector: 'app-my-score-filter-bar',
    imports: [DxTagBoxModule, DxDateRangeBoxModule, DxButtonModule],
    templateUrl: './my-score-filter-bar.component.html',
})
export class MyScoreFilterBarComponent implements OnInit {
    @Input() siteDataSource: AspNetData.CustomStore;
    @Input() vendorDataSource: AspNetData.CustomStore;

    @Output() filtersChanged = new EventEmitter<MyScoreFilters>();
    @Output() exportRequested = new EventEmitter<void>();

    protected dateRange: [Date, Date] = [new Date(), new Date()];
    protected selectedVendors: string[] = [];
    protected selectedSites: string[] = [];

    ngOnInit(): void {
        const to = new Date();
        const from = new Date();
        from.setMonth(from.getMonth() - 1);
        this.dateRange = [from, to];
        this.emitFilters();
    }

    protected onFiltersChanged(): void {
        this.emitFilters();
    }

    protected onExport(): void {
        this.exportRequested.emit();
    }

    private emitFilters(): void {
        const [from, to] = this.dateRange;
        if (!from || !to) return;

        this.filtersChanged.emit({
            from,
            to,
            vendorIds: this.selectedVendors.length ? this.selectedVendors : undefined,
            siteIds: this.selectedSites.length ? this.selectedSites : undefined,
        });
    }
}
